import { useMemo } from 'react';
import { columnOnePath, documentOnePath } from '@/utils/router/links';
export const usePopularListColumnViewData = (args) => {
    const { populars } = args;
    return useMemo(() => {
        if (!populars) {
            return undefined;
        }
        const makeRankingData = (popular) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const { column, document } = popular;
            if (column) {
                return {
                    isLimit: column.is_limit,
                    link: columnOnePath(column.weight_level, column.url_code),
                    thumbnailSrc: ((_b = (_a = column.thumbnail_picture) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.src) || '',
                    thumbnailWebpSrc: (_d = (_c = column.thumbnail_picture) === null || _c === void 0 ? void 0 : _c.webp) === null || _d === void 0 ? void 0 : _d.src,
                    title: column.title,
                };
            }
            if (document) {
                return {
                    isLimit: document.is_limit,
                    link: documentOnePath(document.weight_level, document.id),
                    thumbnailSrc: ((_f = (_e = document.thumbnail_picture) === null || _e === void 0 ? void 0 : _e.default) === null || _f === void 0 ? void 0 : _f.src) || '',
                    thumbnailWebpSrc: (_h = (_g = document.thumbnail_picture) === null || _g === void 0 ? void 0 : _g.webp) === null || _h === void 0 ? void 0 : _h.src,
                    title: document.title,
                };
            }
            return {
                isLimit: false,
                link: '',
                thumbnailSrc: '',
                thumbnailWebpSrc: '',
                title: '',
            };
        };
        return populars.map((popular) => (Object.assign({ articleType: popular.type, id: popular.id }, makeRankingData(popular))));
    }, [populars]);
};
export const usePopularListProfessionalViewData = (args) => {
    const { items: popularProfessionals } = args;
    return useMemo(() => {
        if (!popularProfessionals) {
            return undefined;
        }
        return popularProfessionals.map((professional) => ({
            consultantUnitId: professional.url_code,
            firstName: professional.first_name,
            id: professional.id,
            lastName: professional.last_name,
            organizationName: professional.organization_name,
            photo: professional.photo,
            type: professional.type,
        }));
    }, [popularProfessionals]);
};
